module.exports = __webpack_public_path__ + "static/images/circle.19rm-Gs.svg";